import api from "./index";

export const financialSingleSignOnService = async () =>
  await api.get("/financial/access-information");
